<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div
    class="d-flex align-center justify-center"
  >
    <div
      v-if="isYear && priceType!=='one_time'"
      class="mr-1 text-truncate"
      style="position:relative;"
    >
      <span class="font-weight-bold">{{ $t('AnnualFee') }}</span>{{ $t('TheLowest') }}
    </div>
    <div
      class="text-no-wrap"
      style="position:relative;"
    >
      {{ realPriceAmount * realCount | priceDisplay }}
    </div>
    <div
      v-if="priceType!=='one_time'"
      class="text-truncate"
      style="position:relative;"
    >
      /{{
        $t('Monthly')
      }}
    </div>
    <v-spacer />
    <div
      v-if="priceType!=='one_time' && !justDisplay"
      class="d-flex align-center justify-center"
    >
      <v-checkbox
        v-model="isYear"
        hide-details
        :label="$t('AnnualFee')"
        @change="changeStatus"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StripePriceDisplay',
  data: function () {
    return {
      isYear: true
    }
  },
  props: {
    priceType: {},
    price: {},
    realCount: {
      default: 1
    },
    justDisplay: {}
  },
  computed: {
    isYearPrice () {
      return this.price.find(it => it.interval === 'year') ?? this.price[0]
    },
    isMonthPrice () {
      return this.price.find(it => it.interval === 'month') ?? this.price[0]
    },
    realPriceAmount () {
      return (this.type !== 'one_time' ? (this.isYear ? this.isYearPrice.unit_amount / 100 / 12 : this.isMonthPrice.unit_amount / 100) : this.price.unit_amount / 100)
    }
  },
  methods: {
    changeStatus () {
      this.$emit('isYear', this.isYear)
    }
  }
}
</script>

<style scoped>

</style>
